import { Koi } from '@ksyos/koi';
import type { InputField } from '../formEngine.types';
import type { GenericData, GenericDataKey } from './generic.types';

export const patient_verzekeringskosten_akkoord_field: InputField<GenericData> = {
    draftSchema: Koi.boolean().allow(null),
    finalSchema: Koi.boolean().valid(true),
    initialValue: null,
    key: 'patient_verzekeringskosten_akkoord',
    label: '',
    type: 'custom',
};

const genericKeys: GenericDataKey[] = ['patient_verzekeringskosten_akkoord'];

export function isGenericKey(key: string): key is GenericDataKey {
    return genericKeys.some((genericKey) => genericKey === key);
}
